module.exports = __webpack_public_path__ + "img/116.17dae2d0.jpg";